export interface VcenterWebComponentSchema {
  // all the data needed for rendering
}

export interface VcenterSpecifics {
  hostname: string;
  username: string;
  port: number;
  password: string;
  retryAuthentication: boolean;
  retryAuthenticationMaxAttempts: number;
  retryAuthenticationTimeToWait: number;
  verifyTLSCertificate: boolean;
  viewType: number;
}

export enum ViewTypes {
  HostsAndClusters = 1,
  VmsAndTemplates = 2,
}
